import { axiosAPIUrl, Parameter } from '@/api/index'

/**
 * 商城模块
 * CG003获取商品列表
 * @param parameter
 */
export function getCyStoreGoodsList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
    url: "/cykjStore/GetGoodsInfo/getCyStoreGoodsList",
    method: "get",
    params: parameter,
  });
}

/**
 * 商城模块
 * 获取购物车中商品套餐数量
 * @param parameter
 */
export function getShoppingCount(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
    url: "/cykjStore/ShoppingCart/getShoppingCount",
    method: "get",
    params: parameter,
    extraParams: { showLoading: false }
  });
}
